import { createStore } from "./_createStore";

type ProceduresState = {
  procedureFinalizing: boolean;
  setProcedureFinalizing: (value: boolean) => void;
};

export const useProceduresStore = createStore<ProceduresState>(
  (set) => ({
    procedureFinalizing: false,
    setProcedureFinalizing: (procedureFinalizing) =>
      set({ procedureFinalizing }),
  }),
  "ProceduresStore",
);
